import { parsePhoneNumberFromString } from "libphonenumber-js";

/**
 * Formats a phone number from the server into a format that our front end
 * uses for the phone form input.
 */
export const formatServerPhoneNumber = (phone: string | undefined | null) => {
  if (!phone) {
    return undefined;
  }
  // Stored in E.164 (e.g., +15086548804)
  const phoneNumber = parsePhoneNumberFromString(phone, "US");
  if (!phoneNumber?.isValid()) {
    return undefined;
  }
  // Returns national (e.g., (508) 658 8805) which is what our front end uses
  // for the phone form input
  return phoneNumber.formatNational();
};

/**
 * Formats a phone number from the client into a format that our backend
 * expects.
 */
export const formatClientPhoneNumber = (phone: string): string | undefined => {
  // constraint: `extract: false` — the parser otherwise pulls a number out of
  // surrounding prose.
  const phoneNumber = parsePhoneNumberFromString(phone, {
    defaultCountry: "US",
    extract: false,
  });

  if (!phoneNumber?.isValid()) {
    return undefined;
  }

  // Format the number to E.164 (e.g., +15086548804)
  return phoneNumber.format("E.164");
};

/**
 * constraint: not `isValidPhoneNumber(phone, "US")` — that treats the country
 * as a default for input without a prefix, so an explicit `+44` validates as a
 * valid GB number.
 */
export const isValidUsPhoneNumber = (phone: string): boolean => {
  const phoneNumber = parsePhoneNumberFromString(phone, {
    defaultCountry: "US",
    extract: false,
  });
  return phoneNumber?.isValid() === true && phoneNumber.country === "US";
};

export const phoneTelUrl = (phone: string): string | undefined => {
  const parsed = parsePhoneNumberFromString(phone, "US");
  if (!parsed?.isValid()) {
    return undefined;
  }
  return `tel:${parsed.number}${parsed.ext ? `;ext=${parsed.ext}` : ""}`;
};
